"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LegalECommLoginServiceConfiguration = require("./LegalECommLoginServiceConfiguration");

var _LegalECommLoginServiceConfiguration2 = _interopRequireDefault(_LegalECommLoginServiceConfiguration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_LegalECommLoginServi) {
  _inherits(_class, _LegalECommLoginServi);

  function _class() {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this));

    _this.estoreLocation = "https://stg.store.legal.thomsonreuters.com/law-products";
    return _this;
  }

  return _class;
}(_LegalECommLoginServiceConfiguration2.default);

exports.default = _class;